function getComp(name) {
  return import(
    `./${name}.vue`
  );
}

export const route = {
  path: '/launchApplication',
  name: 'launchApplication',
  component: getComp.bind(null, 'LaunchApplication'),
  meta: {
    matchNav: 'launchApplication',
  },
  // children: [{
  //   path: 'teamBudget',
  //   name: 'budgetManage.teamBudget',
  //   component: getComp.bind(null, 'TeamBudget'),
  //   meta: {
  //     matchNav: 'budgetManage.teamBudget',
  //   },
  // }, ],
};